module.exports = "/images/8a6f07fb62bc2fb75aa67efc2f29c31a.svg";